<template>
    <div class="bgc">
        {{"暂无问卷"}}
    </div>
</template>

<script>

    export default {
        data() {
            return {
                test: false,
                // flag: false,
                dingYue: "",
                // 后台数据
                id: 0,
                examId: 0,
                exam: "",
                // 试题列表
                examList: [],
                // 答题卡数据
                cardList: [],
                num: 0,
                // 答案
                answer: [],
            };
        },
        mounted() {

        }
    };
</script>
<style lang="less" scoped>
    .bgc {
        text-align: center;
        font-size: 22px;
        margin-top: 100px;
        width: 100%;
        min-height: 100vh;
        box-sizing: border-box;
        background-color: #f5f5f5;
    }
</style>
